module.exports = __webpack_public_path__ + "img/853fa2b.png";